export default function setupRouterGuards(router) {
    router.beforeEach((to, from, next) => {
        if (to.path === '/login') {
            next()
        } else {
            const accessToken = window.localStorage.getItem('accessToken');

            // Check if user is authenticated
            if (accessToken !== 'null' && accessToken !== null && accessToken !== undefined) {
                if (to.path === '/') {
                    next('/physicians')
                } else {
                    next()
                }
            } else {
                next('/login')
            }
        }
    });
}